// QUICKBUY FORM HANDLER
(function ($) {
   document.addEventListener("DOMContentLoaded", function () {
      $('body').click(function (e) {
         if (e.target.classList.contains("card-quickbuy__label")) {
            const target = e.target;

            const parentFieldset = target.closest("fieldset")
            parentFieldset.querySelector("label.checked")?.classList.remove("checked");
            target.classList.add("checked");

            const isSoldout = target.classList.contains('soldout');
            const compreJunto = target.closest('.product-item--compre-junto')

            if (compreJunto) {
               compreJunto.dataset.variantId = target.dataset.variantId
               const addButton = compreJunto.querySelector('.card-product__add-button')
               if (
                  (isSoldout && compreJunto.classList.contains('checked')) ||
                  (!isSoldout && !compreJunto.classList.contains('checked'))
               ) {
                  $(addButton).trigger('click')
               }
            }

            const form = target.closest('.card-quickbuy--form')
            const submitButton = form.querySelector(".card-quickbuy__submit")
            if (submitButton) {

               if (!form.classList.contains("card-quickbuy--kit")) {
                  
                  if (isSoldout) {
                     submitButton.textContent = window.card_soldout;
                     submitButton.disabled = true;
                  } else {
                     submitButton.textContent = window.card_add_to_cart
                     submitButton.disabled = false;
                  }

                  $(submitButton).show();
               } else {
                  const fieldsets = form.querySelectorAll("fieldset")
                  const selectedRadios = form.querySelectorAll("label.checked");

                  let isSoldout = false;
                  if (selectedRadios.length == fieldsets.length) {
                     selectedRadios.forEach((radio) => {
                        if (radio.classList.contains("soldout")) {
                           isSoldout = true;

                        }
                     })

                     if (isSoldout) {
                        submitButton.textContent = window.card_soldout;
                        submitButton.disabled = true;
                     } else {
                        submitButton.textContent = window.card_add_to_cart
                        submitButton.disabled = false;
                     }

                     $(submitButton).show();
                  }
               }
            }
         }


      })

      $('body').click(function (e) {
         if (e.target.classList.contains('card-quickbuy__submit')) {
            const submitButton = e.target;
            e.preventDefault();
            submitButton.disabled = true;
            const form = submitButton.closest(".card-quickbuy--form");
            const isKit = form.classList.contains("card-quickbuy--kit");
            let formData = {
               items: []
            }

            if (!isKit) {
               const input = form.querySelector("label.checked")
               const isSoldout = input.classList.contains('soldout');


               if (!isSoldout) {
                  formData.items.push({
                     id: input.dataset.variantId,
                     quantity: 1
                  });
               }

            } else {
               const fieldsets = form.querySelectorAll("fieldset")
               const inputs = form.querySelectorAll(".card-quickbuy__radio:not(.soldout)")

               // 

               if (inputs.length == fieldsets.length) {
                  inputs.forEach((input) => {
                     formData.items.push({
                        id: input.dataset.variantId,
                        quantity: 1
                     });
                  })
               }
            }

            if (formData.items.length > 0) {
               fetch(window.Shopify.routes.root + "cart/add.js", {
                     method: "POST",
                     headers: {
                        "Content-Type": "application/json",
                     },
                     body: JSON.stringify(formData),
                  })
                  .then((response) => {
                     Shopify.getCart((cart) => {
                        window.updateCart(cart);
                     });
                     submitButton.disabled = false;
                     return response.json();
                  })
                  .catch((error) => {
                     console.error("Error:", error);
                  });
            }
         }
      })
   })
})(jQuery)